'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.CalibrationAnalysis.Constants', []).constant('CalibrationAnalysisConstants', {
  UNTRUNCATED_DEMAND_METRIC: 'Untruncated Demand',
  IDV_BOOKINGS_METRIC: 'Idv Bookings',
  DEFAULT_PAGE_LIMIT: 10000,
  DEFAULT_DATE_FROM: 366,
  DEFAULT_DATE_TO: 1,
  HEP_TYPE_RTP: 'RTP',
  HEP_TYPE_LOGIT: 'Logit',
  READING_TIME_FORMAT: 'HHmm',
  READING_TIME_GRID_DISPLAY_FORMAT: 'HH:mm',
  READING_TIME_CHART_TICK_FORMAT: 'HH',
  SCENARIO_NAME_PUBLISHED: 'PUBLISHED',
  CHART_BUCKET_SETTINGS: {
    MIN: 4,
    MAX: 8,
    ROUND_OFF_FACTOR: 10
  },
  CHART_LABEL: {
    'time-of-day': 'Time Of Day',
    'travel-time': 'Travel Time',
    'fare': 'Fare'
  },
  CHART_TYPES: {
    TIME_OF_DAY: 'time-of-day',
    TRAVEL_TIME: 'travel-time',
    FARE: 'fare'
  },
  DOW: [{
    label: 'Mon',
    value: 'MONDAY'
  }, {
    label: 'Tue',
    value: 'TUESDAY'
  }, {
    label: 'Wed',
    value: 'WEDNESDAY'
  }, {
    label: 'Thu',
    value: 'THURSDAY'
  }, {
    label: 'Fri',
    value: 'FRIDAY'
  }, {
    label: 'Sat',
    value: 'SATURDAY'
  }, {
    label: 'Sun',
    value: 'SUNDAY'
  }],
  ENDPOINT_URL: {
    HEP_ALL_URL: 'configuration/hep/all?type=',
    HEP_URL: 'configuration/hep?type=',
    SERVICES: 'configured/service',
    SAVE: 'configuration/hep/bulk',
    PUBLISH: 'domain/dataRecovery/publish/profiles',
    REPUBLISH: 'domain/dataRecovery/republish/profiles',
    UPDATE: 'domain/logitCalibration',
    HEP_ALL_NAME_URL: 'configuration/hep/all/name?type='
  },
  COLOR_THEME: {
    FIXED: '#6FA8DC',
    SCHEDULED: '#376092',
    USER: '#864123'
  },
  SLIDER_SET_UP: {
    min: -24,
    max: 24,
    step: 1
  },
  BAR_DATA_TYPES: {
    USER: 'user',
    SYSTEM: 'system'
  },
  CHART_XAXIS_ROTATION: {
    DEG_15: {
      x: -10,
      y: 10,
      dy: '1.15em',
      transform: 'rotate(-15)'
    },
    INDENT_NO_ROTATE: {
      x: 6,
      y: 5,
      dy: '1.15em'
    }
  },
  SHARES_UPDATE_SCENARIO: {
    ADD: 'add-user-adjustments',
    REMOVE: 'remove-user-adjustments'
  },
  LOGIT_VIEW_TYPES: {
    FIXED: 'fixed',
    SCHEDULED: 'scheduled',
    COMBINED: 'fixed-scheduled'
  },
  CALIBRATION_STATUSES: {
    PUBLISHED: 'Completed',
    INACTIVE: 'Inactive',
    CREATED: 'FINISHED-PROCESSING'
  },
  LOGIT_HEP_PROFILE_KEYS: ['_id', 'type', 'hepKey', 'priority', 'properties'],
  LOGIT_PARAM_KEYS_TO_COPY: ['modelElapsedTimeLogit', 'userElapsedTimeLogit', 'orginalElapsedTimeLogit', 'originalUserElapsedTimeLogit', 'elapsedTimeLogit', 'modelRelativeFareLogit', 'userRelativeFareLogit', 'originalFareLogit', 'originalUserFareLogit', 'relativeFareLogit', 'logitTimeOfDayPreferences'],
  LOGIT_PROFILE_ATTRIBUTE_KEYS: ['origin', 'destination', 'dayOfWeek', 'classSetId', 'significantPOS', 'scenarioName'],
  LOGIT_PARAM_KEYS: ['_id', 'id', 'startReadingTimeInterval', 'logitClassPreferences', 'modelElapsedTimeLogit', 'userElapsedTimeLogit', 'elapsedTimeLogit', 'relativeFareLogit', 'modelRelativeFareLogit', 'userRelativeFareLogit'],
  TIME_OF_DAY_PREFERENCES_KEYS: ['_id', 'id', 'timeOfDayStart', 'timeOfDayPreferenceCoefficient', 'userTimeOfDayPreferenceCoefficient', 'modelTimeOfDayPreferenceCoefficient'],
  REVIEW_VIEW_TYPES: {
    FIXED: 'fixed',
    SCHEDULED: 'scheduled',
    FIXED_SCHEDULED: 'fixed-scheduled'
  }
});